(function() {
	ko.components.register('player-play-button', {
		template: { element: 'template-player-play-button' },
		viewModel: {
			createViewModel: (params, info) => {
				const autoPlayElement = $('.player-play-button-autoPlay', info.element);

				const playHandler = typeof params['play'] == 'function' ? params['play'] : function() {};
				const autoPlayTimeout = typeof params['autoPlayTimeout'] != 'undefined' ? params['autoPlayTimeout'] : ko.observable(0);

				const viewModel = {
					visible: params['visible'] || true,
					play() {
						autoPlayTimeout(0);
						playHandler();
					},
					cancel() {
						autoPlayElement.stop()
							.animate({'stroke-dashoffset': 240}, 500, () => autoPlayTimeout(0))
					},
					isShowCancel() {
						ko.computed(() => autoPlayTimeout() > 0);
					}
				};

				autoPlayTimeout.subscribe(timeout => {
					if(timeout) {
						autoPlayElement.stop()
							.css({'stroke-dashoffset': 240})
							.animate({'stroke-dashoffset': 0}, timeout, () => viewModel.play())
						;
					} else {
						autoPlayElement.stop()
							.css({'stroke-dashoffset': 240})
						;
					}
				});


				return viewModel;
			}
		}
	});
})();
